import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import ContactStatus from "@/models/Contacts/ContactStatus";

export default class UpdateContactStatusRequest extends BaseUpdateRequest {
    status: ContactStatus;
}